// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3D-sg","left":"StickyBox_left__3EeIT","right":"StickyBox_right__31AIh"};